import { Loader } from '@mantine/core'
import { FileText } from 'lucide-react'

import Button from 'src/components/Buttons/Button/Button'

interface VoEDocument {
  documentId: string
  fileName: string
  fileType?: string
  voeDocumentType: string
}

const VoEConsentCard = ({
  onPreview,
  loading,
  documents = [],
  onDocumentClick,
}: {
  onPreview: () => void
  loading: boolean
  documents?: VoEDocument[]
  onDocumentClick?: (doc: VoEDocument) => void
}) => {
  // Filter to consent and response documents
  const consentDoc = documents.find((d) => d.voeDocumentType === 'CONSENT_PDF')
  const responseDoc = documents.find(
    (d) => d.voeDocumentType === 'RESPONSE_PDF'
  )

  return (
    <div className="flex w-full flex-col gap-4 rounded-lg border border-doubleNickel-gray-200 p-5">
      <div className="text-md flex w-full flex-row items-center justify-between gap-2 font-semibold text-doubleNickel-black">
        Documents
      </div>

      <div className="flex flex-col gap-3">
        {/* Driver Consent — use Document record if available, else fall back to S3 link */}
        <div className="flex flex-row items-center gap-3">
          <FileText size={16} strokeWidth={1.5} className="text-doubleNickel-gray-500" />
          <div className="text-sm font-medium text-doubleNickel-gray-700">
            Driver Consent
          </div>
          <div className="ml-auto">
            {!loading && (
              <Button
                onClick={() => {
                  if (consentDoc && onDocumentClick) {
                    onDocumentClick(consentDoc)
                  } else {
                    onPreview()
                  }
                }}
                variant="subtle"
                text="Review Form"
              />
            )}
            {loading && <Loader className="xs" />}
          </div>
        </div>

        {/* Response PDF — only show if Document record exists */}
        {responseDoc && (
          <div className="flex flex-row items-center gap-3">
            <FileText size={16} strokeWidth={1.5} className="text-doubleNickel-gray-500" />
            <div className="text-sm font-medium text-doubleNickel-gray-700">
              {responseDoc.fileName || 'VoE Response'}
            </div>
            <div className="ml-auto">
              <Button
                onClick={() => onDocumentClick?.(responseDoc)}
                variant="subtle"
                text="Review Form"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default VoEConsentCard
